import {Fab} from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import {useNavigate} from "react-router-dom";

const GoToAdminButton = () => {
    const navigate = useNavigate();

    return <>
        <Fab sx={{position: 'fixed', right: '30px', bottom: '30px'}} onClick={() => navigate('/admin/')} aria-label="Vai nella sezione admin" color='primary'>
            <SettingsIcon />
        </Fab>
    </>
}

export default GoToAdminButton